// Environment Configuration
// Update these values for your Vercel deployment

export const ENV_CONFIG = {
  // Development (localhost)
  development: {
    GITHUB_CALLBACK_URL: 'http://localhost:5173/auth/github/callback',
    BASE_URL: 'http://localhost:5173',
    ENVIRONMENT: 'development'
  },
  
  // Production (Vercel)
  production: {
    GITHUB_CALLBACK_URL: 'https://bootminds-elite-two.vercel.app/auth/github/callback',
    BASE_URL: 'https://bootminds-elite-two.vercel.app',
    ENVIRONMENT: 'production'
  }
};

// Auto-detect environment
export const getCurrentEnvironment = () => {
  if (typeof window === 'undefined') return 'development';
  
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }
  
  return 'production';
};

// Get current environment config
export const getCurrentConfig = () => {
  const env = getCurrentEnvironment();
  return ENV_CONFIG[env];
};

// Get GitHub callback URL for current environment
export const getGitHubCallbackUrl = () => {
  // Temporarily force localhost for testing
  return 'http://localhost:5173/auth/github/callback';
};

// Get base URL for current environment
export const getBaseUrl = () => {
  return getCurrentConfig().BASE_URL;
};
